export const DynamicDataAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'DynamicDataAdExtension',
    },
  },
};
